import { HSLColor } from "../../../../../library-js/colors/HSLColor";
import { ElementType } from "../../../../../library-js/dom-tools/ElementType";
import { CanvasDrawer } from "../../../../../library-js/dom/CanvasDrawer";
import { MultiString } from "../../../../../library-js/i18n/MultiString";
import { ContextMenu } from "../../../../../library-templates/context--menu/ContextMenu";
import { RokojoriContextMenu } from "../../../context-menu/RokojoriContextMenu";
import { AppLocales } from "../../../i8/AppLocales";
import { RokojoriWebAppToolbar } from "../../rokojori/RokojoriWebAppToolbar";
import { RokojoriWebAppUI } from "../../rokojori/RokojoriWebAppUI";
import { InspectorView } from "./InspectorView";
import { ToolbarMenu } from "./ToolbarMenu";
import { WaveformView } from "./WaveformView";

export class AudioEditorUI extends RokojoriWebAppUI
{  
  _waveformView:WaveformView;
  _inspectorView:InspectorView;

  async initialize():Promise<void>
  {
    ToolbarMenu.create( this.toolbar ); 

    this._waveformView = new WaveformView( this );
    this._inspectorView = new InspectorView( this );

    await this._waveformView.initialize();
    await this._inspectorView.initialize();

    return Promise.resolve();
    
  }

}